import type { Technique } from '../types';
import { DISPLACEMENT_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type DisplacementState } from './render';

export const displacement: Technique<DisplacementState> = {
  id: 'displacement',
  name: 'Konturverschiebung',
  category: 'noise',
  description: 'Verschiebt die Konturpunkte entlang ihrer Normalen, wahlweise als Schar von Offsetkonturen.',
  params: DISPLACEMENT_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
